import { inject, Injectable } from '@angular/core';
import { FirestoreService } from '../firestore.service';
import { NotFoundException } from '../not-found-exception';

export type ProfileRisk = {
  id: string;
  updated_at: Date;
  created_at: Date;
  person_id: string;
  concern: string;
  investing_knowledge: string;
  investment_summary: string;
  value_drop: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileRisksService {
  private firestoreService = inject(FirestoreService);

  private collectionPath = 'ProfileRisks';

  async create(ProfileRisk: ProfileRisk): Promise<string> {
    const newID = this.firestoreService.generateId([this.collectionPath]);
    ProfileRisk.id = newID;
    await this.firestoreService.set([this.collectionPath, newID], ProfileRisk);
    return newID;
  }

  async getOne(id: string): Promise<ProfileRisk> {
    return await this.firestoreService.docOnce<ProfileRisk>([this.collectionPath, id]);
  }

  async getByPerson(personId: string): Promise<ProfileRisk[]> {
    return await this.firestoreService.colOnce<ProfileRisk>({
      pathSegments: [this.collectionPath],
      where: ['person_id', personId],
    });
  }

  async getMostCurrentByPerson(personId: string): Promise<ProfileRisk> {
    const profiles = await this.firestoreService.colOnce<ProfileRisk>({
      pathSegments: [this.collectionPath],
      where: ['person_id', '==', personId],
      orderBy: ['created_at', 'desc'],
      limit: 1,
    });
    if (profiles.length > 0) {
      return profiles[0];
    } else {
      throw new NotFoundException(`ProfileRisk not found for ${personId}`);
    }
  }

  async update(id: string, profileRisk: ProfileRisk): Promise<void> {
    return await this.firestoreService.update([this.collectionPath, id], profileRisk);
  }
}
